{
  "nl": {
    "marketplace_partner": {
      "contact_me": {
        "success": "Wij nemen binnenkort contact met u op.",
        "failure": "Er trad een onverwachte fout op.",
        "button": "Neem contact met mij op!"
      }
    }
  }
}
